import { QuestionnaireSlug } from '../../OvernightServiceContainer/api/getOvernightQuestionnaire';

export const SittingPreferences = {
  title: 'Sitting info',
  dog_notes: {
    title: 'Add Sitting notes (required)',
    identifier: 'dog_notes',
    placeholder: 'e.g. food or medicine requests? Where does your pet like to sleep? Specific times your dog likes to walk. Home notes. Favorite toys... Please be as detailed as possible.',
    warning: 'Warning: Please do not put sensitive info here as it will be shared with all Pet Caregivers.',
    value: '',
  },
  questions_title: 'Sitting preferences',
  sitting_questionnaire_slug: 'sitting-owner-questionnaire-v4' as QuestionnaireSlug,
  questions: [
    {
      title: 'Is your pet up to date with all of their shots? (required)',
      subtitle: '',
      id: 1,
      identifier: 'sitting shots up to date',
      object_type: 'boolean',
      type: 'question',
      parent_id: 0,
      category_id: 1,
      position: 0,
      required: true,
      value: false,
    },
    {
      title: 'I would like photo and video updates during the sitting.',
      subtitle: '',
      id: 15,
      identifier: 'sitting should send updates',
      object_type: 'toggle',
      type: 'question',
      parent_id: 0,
      category_id: 15,
      position: 0,
      required: false,
      value: false,
    },
    {
      title: 'Should the sitter stay over?',
      subtitle: '',
      id: 2,
      identifier: 'sitting sitter should stay over',
      object_type: 'boolean',
      type: 'question',
      parent_id: 0,
      category_id: 2,
      position: 0,
      required: false,
      value: false,
    },
    {
      title: 'I prefer my pet not be left alone for more than 4 hours.',
      subtitle: '',
      id: 11,
      identifier: 'sitting leaving dog alone ok',
      object_type: 'toggle',
      type: 'question',
      parent_id: 0,
      category_id: 11,
      position: 0,
      required: false,
      value: false,
    },
  ],
};
